import { Box, Stack, styled, Typography } from '@mui/material'

export const GolfScorecardContainer = styled(Box)(({ theme }) => ({
  background: theme.palette.background.paper,
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.grey[800],
  width: '100%',
  gap: theme.spacing(2),
  padding: theme.spacing(1, 2),
  [theme.breakpoints.down('sm')]: {
    overflowX: 'auto',
    flexWrap: 'nowrap',
    scrollbarWidth: 'thin',
    padding: theme.spacing(1),
    gap: theme.spacing(1),
    flexDirection: 'column',
    alignItems: 'flex-start'
  }
}))

export const HeaderContent = styled(Stack)(({ theme }) => ({
  alignItems: 'flex-start',
  fontWeight: 'bold',
  marginRight: 1,
  maxWidth: theme.spacing(25.75),
  [theme.breakpoints.down('sm')]: {
    maxWidth: '100%',
    marginRight: 0,
    width: '100%'
  }
}))

export const PlayerInfo = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  padding: 1,
  gap: theme.spacing(1)
}))

export const CountryFlag = styled(Box)(({ theme }) => ({
  width: theme.spacing(2.25),
  marginRight: 1.25,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}))

export const DisplayName = styled(Typography)(({ theme }) => ({
  fontSize: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.spacing(1.5)
  }
}))

export const IdTeamInfo = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: theme.spacing(0.5, 0),
  gap: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    fontSize: '0.75rem'
  }
}))

export const ScoreboardCell = styled(Stack)(({ theme }) => ({
  fontSize: theme.spacing(1.5),
  marginLeft: 1,
  marginRight: 1.5,
  color: theme.palette.text.primary,
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.spacing(1.25),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5)
  }
}))
